import CheckIcon from '@mui/icons-material/Check';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from 'common/Button';
import ButtonSecondary from 'common/ButtonSecondary';

import { useState } from 'react';

export default function FilterButton({ getAppointmentList, providers = [] }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selected, setSelected] = useState(false);
    const [selectedProviderId, setSelectedProviderId] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleGetFilteredAppintments = (providerId) => {
        if (providerId) {
            setSelectedProviderId(providerId);
            getAppointmentList({
                providerId: providerId,
            });
            setSelected(true);
        } else {
            setSelectedProviderId(null);
            getAppointmentList();
            setSelected(false);
        }
        setAnchorEl(null);
    };

    // If the business has no providers, don't show the filter button
    if (!providers || providers.length === 0) {
        return null;
    }

    return (
        <div>
            {selected ? (
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    className={`flex items-center gap-2  !bg-[var(--highlight-accent-primary-hover,#B24228)]
                    `}
                >
                    <span>Filter</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                        />
                    </svg>
                </Button>
            ) : (
                <ButtonSecondary
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    className={`flex items-center gap-2 ${open ? '!bg-[#FF5F39] !text-white' : ''}`}
                >
                    <span>Filter</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                        />
                    </svg>
                </ButtonSecondary>
            )}

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                sx={{
                    left: '-220px',
                }}
                PaperProps={{
                    sx: {
                        boxShadow: '0px 4px 100px rgba(62, 62, 74, 0.07), 0px 0px 24px rgba(62, 62, 74, 0.10)', // Drop shadow
                        borderRadius: '0 0 8px 8px',
                    },
                }}
            >
                <MenuItem
                    onClick={() => handleGetFilteredAppintments(null)}
                    className="flex justify-between items-center"
                    sx={{
                        '&:hover': {
                            backgroundColor: 'var(--Structural-Structure-1, #F5F1ED)',
                        },
                    }}
                >
                    <span>All</span>
                    {selectedProviderId === null && <CheckIcon className="ml-auto" />}
                </MenuItem>

                {providers.map((provider) => (
                    <MenuItem
                        key={provider.id}
                        onClick={() => {
                            handleGetFilteredAppintments(provider.id);
                        }}
                        className="flex justify-between items-center"
                        sx={{
                            '&:hover': {
                                backgroundColor: 'var(--Structural-Structure-1, #F5F1ED)',
                            },
                        }}
                    >
                        <span>{provider.first_name + ' ' + provider.last_name}</span>
                        {selectedProviderId === provider.id && <CheckIcon className="ml-auto" />}
                    </MenuItem>
                ))}
            </Menu>
        </div>
        /*
            <>
                {showFilter && (
                    <>
                        <ProviderMultiSelect providers={providers} personName={personName} setPersonName={setPersonName} />
                        <Button
                            onClick={() => {
                                getAppointmentList({
                                    providerId: personName,
                                });
                            }}
                        >
                            Apply
                        </Button>
                    </>
                )}
        
                <ButtonSecondary
                    onClick={() => {
                        setShowFilter(!showFilter);
                    }}
                    className={'flex items-center gap-2'}
                >
                    <span>Filer</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                    >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                            />
                        </svg>
                    </ButtonSecondary>
                </>*/
    );
}
